// extracted by mini-css-extract-plugin
export default {"skeletonlistItem":"TextSkeleton_skeletonlistItem__teAkJ","skeletonlinks":"TextSkeleton_skeletonlinks__Iys0v","title":"TextSkeleton_title__6yEYZ"};